import { createRouter, createWebHistory } from 'vue-router'

import { useAuthStore } from '@/stores/authStore'

import LoginView from '@/views/LoginView.vue'
import HomeView from '@/views/HomeView.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),

  routes: [
    {
      path: '/login',
      name: 'login',
      component: LoginView,
      meta: {
        guestOnly: true,
        title: 'Войдите в приложение',
      },
    },

    {
      path: '/',
      name: 'home',
      component: HomeView,
      meta: {
        requiresAuth: true,
        title: 'Кладбища',
      },
    },
    {
      path: '/cemetery/:cemetery_id',
      name: 'cemetery',
      component: () => import('@/views/CemeteryInfo.vue'),
       meta: {
        requiresAuth: true,
        title: 'Информация о кладбище',
      }
    },{
    path: '/cemetery/:cemetery_id/settings',
    name: 'cemeterySettings',
    component: () => import('@/views/CemeterySettingsView.vue'),
    meta: {
      requiresAuth: true,
      title: 'Настройки кладбища',
    }
  }, {
      path: '/map/:cemetery_id',
      name: 'map',
      component: () => import('@/views/MapView.vue'),
      meta: {
        requiresAuth: true,
        title: 'Карта кладбища',
      }
    },
  ],
})

router.beforeEach(async (to) => {
  const authStore = useAuthStore()

  if (!authStore.isInitialized || !authStore.inspectToken()) {
    await authStore.initializeAuth()
  }

  const isAuth = authStore.inspectToken()

  // Только для неавторизованных
  if (to.meta.requiresAuth && !isAuth) {
    return {
      name: 'login'
    }
  }

  // Если уже авторизован — не пускаем на login
  if (to.meta.guestOnly && isAuth) {
    return {
      name: 'home'
    }
  }

  return true
})

export default router